module.exports = __webpack_public_path__ + "static/media/Ku.8bfb516b.PNG";